var React = require('react');

function Messenger (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M256.025.05C117.67-2.678 3.184 107.038.025 245.383a240.703 240.703 0 0085.333 182.613v73.387c0 5.891 4.776 10.667 10.667 10.667a10.67 10.67 0 005.653-1.621l59.456-37.141a264.142 264.142 0 0094.891 17.429c138.355 2.728 252.841-106.988 256-245.333C508.866 107.038 394.38-2.678 256.025.05z","fill":"#2196f3","key":0}),React.createElement("path",{"d":"M424.558 174.983a10.666 10.666 0 00-13.653-2.987l-110.933 60.48-69.013-59.179a10.666 10.666 0 00-14.485.555l-128 128c-4.153 4.178-4.133 10.932.046 15.085a10.666 10.666 0 0012.605 1.811l110.933-60.48 69.077 59.2a10.666 10.666 0 0014.485-.555l128-128a10.666 10.666 0 00.938-13.93z","fill":"#fafafa","key":1})]);
}

Messenger.defaultProps = {"viewBox":"0 0 512.05 512.05"};

module.exports = Messenger;

Messenger.default = Messenger;
